import React, { PureComponent } from "react";
import PropTypes from "prop-types";
//Limitless imports
import CustomerAvatar from "../customer-avatar/CustomerAvatar";
class UserAvatar extends PureComponent {
  render() {
    var _theme$palette$backgr, _theme$palette$backgr2;
    const {
      author,
      thumbnail,
      theme,
      customerAvatarStyle
    } = this.props;
    if (thumbnail) {
      return /*#__PURE__*/React.createElement(CustomerAvatar, null, /*#__PURE__*/React.createElement("img", {
        src: `data:image/png;base64, ${thumbnail}`,
        style: {
          height: 50
        },
        alt: author
      }));
    }
    return /*#__PURE__*/React.createElement(CustomerAvatar, {
      style: {
        backgroundColor: theme ? (_theme$palette$backgr = (_theme$palette$backgr2 = theme.palette.background) === null || _theme$palette$backgr2 === void 0 ? void 0 : _theme$palette$backgr2.userAvatar) !== null && _theme$palette$backgr !== void 0 ? _theme$palette$backgr : theme.palette.background.white : "white",
        color: theme ? theme.palette.secondary.contrastText : "black",
        ...customerAvatarStyle
      }
    }, author ? author.charAt(0).toUpperCase() : "L");
  }
}
export default UserAvatar;
UserAvatar.propTypes = {
  author: PropTypes.string,
  thumbnail: PropTypes.string,
  theme: PropTypes.object,
  customerAvatarStyle: PropTypes.object
};